import {
  RecurrenceAvailabilityPreview,
  RecurrenceStatus,
} from "@/features/RecurringRequests/types";

type ConfirmPreviewInput = {
  sourceDate: string;
  seriesBookingDates: string[];
  included: RecurrenceAvailabilityPreview["included"];
  excluded: RecurrenceAvailabilityPreview["excluded"];
  proposedRemovals: Array<{ date: string }>;
};

/**
 * Splits a THIS_AND_FOLLOWING recurring-request preview into unchanged prior dates,
 * updated this-and-following dates, newly requested dates that are unavailable,
 * and existing dates that will be removed.
 */
export const stitchRecurringRequestConfirmPreview = ({
  sourceDate,
  seriesBookingDates,
  included,
  excluded,
  proposedRemovals,
}: ConfirmPreviewInput) => {
  const unchangedOccurrences = [...seriesBookingDates]
    .filter((date) => date < sourceDate)
    .sort()
    .map((date) => ({ date, warnings: [] as RecurrenceStatus[] }));

  const availableOccurrences = included.filter(
    (occurrence) => occurrence.date >= sourceDate
  );

  const unavailableDates = excluded.filter(
    (exclusion) => exclusion.date >= sourceDate
  );

  return {
    unchangedOccurrences,
    availableOccurrences,
    unavailableDates,
    removedOccurrences: proposedRemovals,
  };
};
